module.exports = __webpack_public_path__ + "static/OGWII_S1-11.2_lazienka_pietro_02-d0d64f1d78d8addfb1202b2d269181e7.jpg";